import { render } from "./Transcripts.vue?vue&type=template&id=8ae30ce8"
import script from "./Transcripts.vue?vue&type=script&lang=js"
export * from "./Transcripts.vue?vue&type=script&lang=js"
script.render = render

export default script